import { Image } from "antd";
import { ReactComponent as DefaultIcon } from '@UI/CustomUploadFile/assets/defaulDoc.svg'
import { ReactComponent as WordIcon } from '@UI/CustomUploadFile/assets/filesIcon/docxIcon.svg'
import { ReactComponent as ExcelIcon } from '@UI/CustomUploadFile/assets/filesIcon/xlsxIcon.svg'
import { ReactComponent as PowerPointIcon } from '@UI/CustomUploadFile/assets/filesIcon/pptxIcon.svg'
import { ReactComponent as PDFIcon } from '@UI/CustomUploadFile/assets/filesIcon/pdfIcon.svg'

export const typeFiles = ({ props }) => ({
    docx: <WordIcon {...props} />,
    doc: <WordIcon {...props} />,
    xlsx: <ExcelIcon {...props} />,
    xls: <ExcelIcon {...props} />,
    pptx: <PowerPointIcon {...props} />,
    ppt: <PowerPointIcon {...props} />,
    pdf: <PDFIcon {...props} />,
    default: <DefaultIcon {...props} />
})

//Funcion para renderizar el icono de un archivo en linea, o una imagen si el tipo de archivo coincide 
export const imageFileRenderHelper = ({ file, svgProps, imageProps, link }) => {
    const fileExtension = file?.split('.').pop().toLowerCase();
    //Determinar si la extension es jpg, png, etc antes de renderizar algun icono
    if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
        return (
            <Image
                className='uploaded-file__image'
                src={file}
                alt={file}
                {...imageProps}
            />
        )
    }
    const icon = typeFiles({ props: svgProps })[fileExtension] || typeFiles({ props: svgProps }).default
    if (link) {
        return (
            <a href={file} target='_blank' rel='noreferrer'>
                {icon}
            </a>
        )
    }
    return icon
}